import React, { Component } from 'react'
import Table from "../../../../components/UI/Table/Table.js";
import { connect } from 'react-redux'
import { sendSelected } from './helper'
import './index.css';
let that = this;
const tableColumns = [
    {
        Header: "",
        accessor: p => <div><input type="radio" name={p.id} value={p.id} onChange={that.onCompanyChanged} /></div>,
        id: "corporate",
        className: 'center',
        maxWidth: 50,
    },
    {
        Header: "Name",
        accessor: "corporateName",
        className: 'center',
    },
    {
        Header: "City",
        accessor: "city",
        className: 'center',
    },
    {
        Header: "GST No",
        accessor: "gstNo",
        className: 'center'
    },
    {
        Header: "TAN No",
        accessor: "tanNo",
        className: 'center'
    },
    {
        Header: "PAN No",
        accessor: "panNo",
        className: 'center'
    },
    {
        Header: "Contact Person",
        accessor: "contactPerson"
    },
    {
        Header: "Contact Number",
        accessor: "contactNumber",
        className: 'center'
    },
    {
        Header: "Contact Email",
        accessor: "contactEmail"
    }

]

class TableView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: {},
      corporate: [],
    }
    this.tabledata = "";
    that = this;
  }

  onCompanyChanged = (e) => {
    let selected = sendSelected(this.props.corporateResult, e.target.value)
    this.props.selectedCounterparty(selected)
  }
  render() {
    return (
      <div className="">
        <Table
          tableData={this.props.corporateResult}
          columns={tableColumns}
          defaultSorted={[
            {
              id: "City",
              desc: false
            }
          ]}
          defaultPageSize={5}
          className="-highlight"
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  corporateResult: state.createScorecard.corporateResult
});

const mapDispatchToProps = (dispatch) => ({

});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableView);
// export default TableView
